<template>
  <div class="pt-8 pb-5">
    <div class="px-5 pt-4">
      <Sidebar></Sidebar>
      <Header>{{ $t('all.scanner_qr_code') }}</Header>
      <div class="text-center">
        <h2 class="text-red pt-4"> {{ $t('all.well_done') }}</h2>
        <p class="text-blue-dark pt-4">{{
          isLeft
            ? $t('all.successfully_scanned_left')
            : $t('all.successfully_scanned_arrived')
        }}</p>
        <img src="/img/QRCODE_OK.png" class="w-4/5 h-4/5" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: 'QrCodeSuccess',
  computed: {
    isLeft() {
      return (
        this.$router.currentRoute &&
        this.$router.currentRoute.query &&
        this.$router.currentRoute.query.action &&
        this.$router.currentRoute.query.action === 'qr_left_confirmed'
      );
    },
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'Home' });
    },
  },
  created() {
    setTimeout(this.goHome, 10000);
  },
};
</script>
